import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SearchTermsAmazonPage } from "~/pages/SearchTerms/amazon/SearchTermsAmazonPage";

export const Route = createFileRoute("/_app/search-terms/amazon")({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.amazonSearchTerms") }],
  }),
  component: SearchTermsAmazonPage,
});
